<template>
  <div v-if="isLoggedIn && isStartedParticipant && isArmWithPortal && !hideNavigationButton" class="portal-navigation-panel" :class="{open: showNavigation}">
    <div v-if="!navigationPages.length && !loading" class="alert alert-danger text-center" role="alert">
      <p>{{ $t('portal.navigationError1') }}</p>
      <p>{{ $t('portal.navigationError2') }}</p>
    </div>

    <ul class="list-unstyled">
      <li v-for="page in navigationPages" class="navigation-list-item">
        <div class="navigation-list-item">
          <h4>
            <router-link class="navigation-link" :to="{ path: `/dashboard${page.path}`}">
              {{ page.name }}
            </router-link>
          </h4>
        </div>
      </li>
    </ul>

    <div class="navigation-bottom d-lg-none">
      <div class="navigation-signout">
        <router-link :to="{name: 'logout'}" class="btn btn-default btn-block">
          <span class="fa fa-sign-out-alt" /> {{ $t('signOut') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState , mapGetters } from 'vuex';


  export default {
    name: "Navigation",
    data() {
      return {}
    },

    computed: {
      ...mapState(['navigationPages', 'showNavigation', 'loading', 'hideNavigationButton']),
      ...mapGetters(['isLoggedIn', 'isStartedParticipant', 'isArmWithPortal']),
    },
    methods: {
      closeNavigation() {
        this.$store.commit('TOGGLE_NAVIGATION');
      }
    },
  }
</script>

<style scoped>

  ul .navigation-list-item:not(:last-child):after {
    content: "";
    display: block;
    height: 1px;
    width: 100%;
    background: #DDD;
  }

  .portal-navigation-panel {
    width: 300px;
    height: 100%;
    padding: 50px 10px 150px 10px;
    border-left: 1px solid #ddd;
    box-shadow: none;
    background-color: #fff;

    top: 0;
    bottom: 0;
    left: -300px;
    position: fixed;
    overflow-y: scroll;
    overflow-x: hidden;

    transition: left .5s ease-out, box-shadow .5s ease-out;
  }

  .portal-navigation-panel.open {
    left: 0;
    box-shadow: 0 5px 10px #ddd;
  }

  @media (min-width: 1200px) {
    .portal-navigation-panel {
      left: 0;
      box-shadow: 0 5px 10px #ddd;
    }
  }

  @media (max-width: 480px) {
    .portal-navigation-panel {
      width: 100%;
      left: -100%;
      max-width: 100%;
    }

    .navigation-bottom {
      position: fixed;
      left: -100%;
      bottom: 0;
      width: 100%;
      background-color: #FFF;
      padding: 0 !important;

      transition: left .5s ease-out;
    }

    .portal-navigation-panel.open .navigation-bottom {
      left: 0;
    }

    .navigation-signout {
      padding: 10px;
    }
  }

  .portal-navigation-panel::-webkit-scrollbar {
    width: 5px;
  }

  .portal-navigation-panel::-webkit-scrollbar-thumb {
    background: #CCC; /* make this brand color? */
  }

  .alert {
    padding: 5px;
  }

  .navigation-list-item {
    padding: 5px 8px;
  }
  .navigation-link {
    display: block;
  }

  .navigation-bottom {
    padding-top: 50px;
  }

  .portal-navigation-panel .navigation-link {
    position: relative;
  }
  .portal-navigation-panel .router-link-exact-active:before {
    content: '\25CF';
    position: absolute;
    left: -12px;
    font-size: 15px;
    opacity: .6;
  }

</style>
